const ITEMS = [
    "VIP Tables",
    "Premium Clubs",
    "Personal Concierge",
    "Seamless Booking",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <div key={item} className="flex items-center">
                <span className="px-10 text-[11px] font-bold uppercase tracking-[0.45em] text-ivory/60">
                    {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" />
            </div>
        ))}
    </div>
);

const TrustMarquee = () => (
    <section
        data-testid="trust-strip"
        className="overflow-hidden border-y border-white/10 bg-[#050505] py-6"
    >
        <div className="marquee-track">
            <Row />
            <Row />
        </div>
    </section>
);

export default TrustMarquee;
